export const CONFIRMED_CREATE_DOCTOR_ACTION = "CONFIRMED_CREATE_DOCTOR_ACTION";
export const CONFIRMED_DELETE_DOCTOR_ACTION = "CONFIRMED_DELETE_DOCTOR_ACTION";
export const CONFIRMED_EDIT_DOCTOR_ACTION = "CONFIRMED_EDIT_DOCTOR_ACTION";
export const CONFIRMED_GET_DOCTORS = "CONFIRMED_GET_DOCTORS";
